import './ContentHero.scss';

import React from 'react';
import { getContentHubDamAsset } from '../../utils/get-contenthub-dam-asset';
import { ContentHeroData } from '../../models/app-data-model';
import ContentHeroColumnContent from '../content-hero-column-content/ContentHeroColumnContent';
import Grid2 from '@mui/material/Grid2';
import { url } from 'inspector';

export type ContentHeroProps = {
  contentHeroData: ContentHeroData;
};

const ContentHero: React.FC<ContentHeroProps> = ({ contentHeroData }: ContentHeroProps) => {
  const backgroundColor = contentHeroData.background_color;
  const backgroundType = contentHeroData.background_type;
  const backgroundImage = getContentHubDamAsset(contentHeroData.background_image_dam);
  
  return <Grid2 container gap={1} className={`content-hero ${backgroundType} ${backgroundColor}`} style={{background: backgroundType === 'bg-image' ? `url(${backgroundImage?.url}) no-repeat`: ''}}>
    {contentHeroData.content.map((contentHeroContent, index) => contentHeroContent.column && <ContentHeroColumnContent key={index} contentHeroColumn={contentHeroContent.column} />)}
  </Grid2>;
};

export default ContentHero;